export const boxShadow = "5px 5px 10px #aaa";
export const boxShadowMedium = "0px 2px 5px #00000087";
export const boxShadowSmall = "0px 1px 2px #0000003d";
